import {
  ComponentParams,
  ComponentRendering,
  Field,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { C44TestimonialCardFields } from '../C44TestimonialCard/C44TestimonialCard.types';

export interface C44TestimonialsProps {
  rendering?: ComponentRendering & {
    params?: ComponentParams;
    placeholders?: C44TestimonialsPlaceholder;
  };
  params?: ComponentParams & C44TestimonialsParams;
  fields?: C44TestimonialsFields;
}

export interface C44TestimonialsFields {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
}

export interface C44TestimonialsParams {
  BackgroundColor?: string;
  NumberOfColumns?: string;
  HeadlineTag?: string;
  ContentAlignment?: string;
  ExpandButtonAlignment?: string;
  ShowOnlyFirstRowOnLoad?: string;
  ExcludeFromTranslation?: boolean;
  AnchorLinkTargetName?: string;
}

export interface C44TestimonialsPlaceholder {
  'testimonial-cards-{*}'?: {
    componentName?: string;
    fields?: C44TestimonialCardFields;
  }[];
}
